export const getArrayFromQuerySelectorAll = (selector: string, target: Document | Element = document) => {
  return Array.from(target.querySelectorAll(selector));
};
